import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { I8N, StringUtil } from "@eres/core";
import { populateTabuLookUp, TabuCountryLookup, TabuLookUp } from "@my-dld/tabuapi";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import TextInputField from "../Form/TextInputField";
import { EidStateFormatter } from "@my-dld/screens/Login/owner/EID";
import PickerInput from "../Form/PickerInput";
import PercentConverter from "../Form/Converters/PercentConverter";
import { CursorPositioner } from "../Form/CurrencyInput";
import { toMobileX } from "@my-dld/screens/MyDLD/MyProfile";
import { RenderProcedureDocs } from "@my-dld/screens/RTRegistration/ProcedureDocuments";
import Popup from "../Popup/Popup";
import { JQModal } from "../Popup/Utils";
import _ from "lodash";
import { Country, getPartyDocs, Party, ProcedureDoc, Role } from "@eres/rtregistrationapi/entities";
import { RTRegistrationApi } from "@eres/rtregistrationapi";
import FixedEidInput, { FixedMobileInput } from "../FixedEidInput";

interface Props {
	role: Role;
	editIndex?: number;
	onDismiss?: ( role?: Role ) => void;
}

interface State {
	role: Role;
	editIndex?: number;
	EnglishName?: string;
	ArabicName?: string;
	Mobile?: string;
	Email?: string;
	EID?: string;
	Passport?: string;
	Country?: TabuCountryLookup;
	Countries: TabuCountryLookup[];
	SharePerc?: string;
	docs: ProcedureDoc[];
	error: { [ k: string ]: string };
	errorMessage?: string;
	docsErrorMessage?: string;
	isLoading: boolean;
}

class AddPartyPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			Countries: [],
			isLoading: true,
			...stateFromProps( props )
		} as State;
	}

	componentDidMount() {
		populateTabuLookUp( TabuLookUp.COUNTRIES, this, () => {
			setTimeout( () => {
				this.setState( { isLoading: false } );
			}, 100 );
		} );
	}

	render() {
		const { isLoading, role, Countries, docs, error, errorMessage, docsErrorMessage } = this.state;
		const roleName = I8N.isRTL() ? role.RoleNameAr : role.RoleName;
		return <React.Fragment>
			<Popup
				id={ "AddPartyPopup" }
				modalMainContainer={ "modal fade" }
				modalSubContainer={ "modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" }
				clickOutsideToDismiss={ false }
				showCloseButton={ true }
				closeClass={ "close modal-close-svg-icon" }
				closeSpanClass={ "close-svg-icon" }
				modalBodyContainer={ "modal-body pb-0" }
				showIcon={ false }
				title={ Strings.party_information + " - " + roleName }
				onDismiss={ () => this.dismissModel() }>
				{ errorMessage && <div className="alert alert-danger col-md-12">{ errorMessage }</div> }
				<div className="row">
					<div className="col-md-12">
						<div className="mandatory-field-info"><small>{ Strings.mandatory_fields_note }</small>
						</div>
					</div>
					<div className="col-md-12 font-weight-bold mb-3">{ Strings.personal_information }</div>
					<div className="col-md-4">
						<TextInputField
							id={ "EnglishName" }
							holder={ this }
							required={ true }
							label={ Strings.name_english }
							type={ "english" }
							error={ error.EnglishName }
							disabled={ role.RoleOrder === 1 }
							containerClassName={ "form-group" }/>
					</div>
					<div className="col-md-4 arabic-field">
						<TextInputField
							id={ "ArabicName" }
							holder={ this }
							required={ true }
							label={ Strings.name_arabic }
							type={ "arabic" }
							error={ error.ArabicName }
							disabled={ role.RoleOrder === 1 }/>
					</div>
					<div className="col-md-4">
						<FixedMobileInput
							id={ "Mobile" }
							holder={ this }
							required={ true }
							label={ Strings.mobile_number }
							error={ error.Mobile }/>
					</div>
					<div className="col-md-4">
						<TextInputField
							id={ "Email" }
							holder={ this }
							required={ true }
							label={ Strings.email }
							error={ error.Email }/>
					</div>
					<div className="col-md-4">
						<FixedEidInput
							id={ "EID" }
							holder={ this }
							required={ true }
							label={ Strings.emirates_id }
							stateFormatter={ EidStateFormatter }
							placeHolder={ "784-XXXX-XXXXXX-X" }
							error={ error.EID }
							disabled={ role.RoleOrder === 1 }/>
					</div>
					<div className="col-md-4">
						<TextInputField
							id={ "Passport" }
							holder={ this }
							required={ true }
							label={ Strings.passport_label }
							error={ error.Passport }
							maxLength={ 15 }
							disabled={ role.RoleOrder === 1 }/>
					</div>
					<div className="col-md-4">
						<PickerInput
							id={ "Country" }
							holder={ this }
							required={ true }
							label={ Strings.nationality }
							items={ Countries }
							formatter={ ( item: TabuCountryLookup ) => I8N.isRTL() ? item.NameAr : item.NameEn }
							toIdentifier={ ( item: TabuCountryLookup ) => item.Identity + "" }
							error={ error.Country }
							disabled={ role.RoleOrder === 1 }/>
					</div>
					<div className="col-md-4">
						<TextInputField
							id={ "SharePerc" }
							holder={ this }
							required={ true }
							label={ Strings.share_percentage }
							type={ "text" }
							converter={ PercentConverter }
							cursorPositioner={ CursorPositioner }
							error={ error.SharePerc }
							disabled={ role.RoleOrder === 1 }/>
					</div>
				</div>
				<RenderProcedureDocs
					procDocs={ docs }
					onDropRejected={ this.onDropRejected }
					onDrop={ this.onDrop }
					onDelete={ this.onDelete }
					errorMsg={ docsErrorMessage }/>
				<div className="modal-footer justify-content-start row">
					<button
						type="button" className="btn btn_1"
						onClick={ this.onSubmit }>{ Strings.submit_label }</button>
					<button type="button" className="btn btn-link" onClick={ this.onReset }>{ Strings.reset }</button>
				</div>
			</Popup>
			{ isLoading && <RenderLoading/> }
		</React.Fragment>;
	}

	private onDropRejected = () => {
		this.setState( {
			docsErrorMessage: Strings.tabu_file_exceed_size,
		} );
	};

	private onDrop = ( doc: ProcedureDoc, files: File[] ) => {
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( doc, file ) );
	};

	private addFile( uploadDoc: ProcedureDoc, file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			uploadDoc.doc = {
				identity: uploadDoc.DocumentName,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
			};
			uploadDoc.Path = undefined;
			this.setState( {
				docsErrorMessage: undefined,
				docs: this.state.docs.map( ( doc: ProcedureDoc ) => {
					return ( uploadDoc.DocumentName === doc.DocumentName ) ? uploadDoc : doc;
				} ),
			} );
		};
		reader.readAsDataURL( file );
	}

	private onDelete = ( identity: any ) => {
		this.setState( {
			docs: this.state.docs.map( ( procDoc: ProcedureDoc ) => {
				if ( procDoc.DocumentName === identity ) {
					procDoc.Path = undefined;
					procDoc.doc = undefined;
					return procDoc;
				}
				return procDoc;
			} ),
		} );
	};

	private onSubmit = () => {
		const { role } = this.state;
		if ( role.RoleOrder === 1 ) {
			this.validateDefaultParty();
		} else {
			this.validateNewParty();
		}
	};

	private onReset = () => {
		this.setState( {
			...stateFromProps( this.props ) as State
		} );
	};

	private validateDefaultParty() {
		if ( this.isDefaultPartyValid() ) {
			this.saveParty();
		}
	}

	private isDefaultPartyValid() {
		const { Mobile, Email, docs } = this.state;
		const error: { [ k: string ]: string } = {};
		let isValid = true;
		let docsErrorMessage = undefined;
		if ( StringUtil.isEmptyStringOrNull( Mobile ) || ( Mobile && ( toMobileX( Mobile ) ).length !== 12 ) ) {
			error.Mobile = Strings.invalid_mobile_number;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( Email ) || ( Email && !StringUtil.isEmailAddress( Email ) ) ) {
			error.Email = Strings.invalid_email_address;
			isValid = false;
		}
		if ( isValid ) {
			const isDocNotAdded = docs.every( ( partyDoc: ProcedureDoc ) => partyDoc.doc == undefined );
			if ( isDocNotAdded ) {
				isValid = false;
				docsErrorMessage = Strings.rt_party_docs;
			}
		}
		this.setState( {
			error: error,
			docsErrorMessage: docsErrorMessage,
		} );
		return isValid;
	}

	private validateNewParty() {
		if ( this.isNewPartyValid() ) {
			if ( !this.isDuplicateParty() ) {
				if ( this.checkTotalShare() ) {
					this.saveParty();
				} else {
					this.setState( {
						errorMessage: Strings.rt_party_share_exceed_validation,
					} );
				}
			} else {
				this.setState( {
					errorMessage: Strings.rt_duplicate_party,
				} );
			}
		}
	}

	private isNewPartyValid() {
		const { EnglishName, ArabicName, Mobile, Email, EID, Passport, Country, SharePerc, docs } = this.state;
		const error: { [ k: string ]: string } = {};
		let isValid = true;
		let docsErrorMessage, errorMessage = undefined;
		if ( StringUtil.isEmptyStringOrNull( EnglishName ) ) {
			error.EnglishName = Strings.required;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( ArabicName ) ) {
			error.ArabicName = Strings.required;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( Mobile ) || ( Mobile && ( toMobileX( Mobile ) ).length !== 12 ) ) {
			error.Mobile = Strings.invalid_mobile_number;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( Email ) || ( Email && !StringUtil.isEmailAddress( Email ) ) ) {
			error.Email = Strings.invalid_email_address;
			isValid = false;
		}
		let isEIDValid = !StringUtil.isEmptyStringOrNull( EID );
		if ( EID && ( EID.length !== 15 || !EID.startsWith( "784" ) ) ) {
			isEIDValid = false;
		}
		let isPassportValid = !StringUtil.isEmptyStringOrNull( Passport );
		isPassportValid = ( Country !== undefined && isPassportValid );
		if ( !isEIDValid && !isPassportValid ) {
			if ( !isEIDValid )
				error.EID = Strings.required;
			if ( StringUtil.isEmptyStringOrNull( Passport ) )
				error.Passport = Strings.required;
			if ( Country == undefined )
				error.Country = Strings.required;
			errorMessage = Strings.rt_party_eid_passport;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( SharePerc ) ) {
			error.SharePerc = Strings.required;
			isValid = false;
		}
		if ( isValid ) {
			const isDocNotAdded = this.state.docs.every( ( partyDoc: ProcedureDoc ) => partyDoc.doc == undefined );
			if ( isDocNotAdded ) {
				docsErrorMessage = Strings.rt_party_docs;
				isValid = false;
			}
		}
		this.setState( {
			error: error,
			docsErrorMessage: docsErrorMessage,
			errorMessage: errorMessage,
		} );
		return isValid;
	}

	private isDuplicateParty() {
		let isDuplicate = false;
		const { role, editIndex, EID, Passport, Country } = this.state;
		if ( role.Parties ) {
			role.Parties.forEach( ( party: Party, index: number ) => {
				if ( editIndex !== index && party.EID === EID ||
					( party.Passport === Passport && party.country && party.country.CountryId === Country!.Identity ) ) {
					isDuplicate = true;
				}
			} );
		}
		return isDuplicate;
	}

	private checkTotalShare() {
		const { role, editIndex } = this.state;
		let total = 0;
		if ( role.Parties ) {
			role.Parties.forEach( ( party: Party, index: number ) => {
				if ( editIndex !== index ) {
					total += party.SharePerc ? party.SharePerc : 0;
				}
			} );
		}
		total += parseFloat( this.state.SharePerc! );
		return ( total <= 100 );
	}

	private saveParty() {
		const state = this.state;
		const party: Party = {
			EnglishName: state.EnglishName,
			ArabicName: state.ArabicName,
			Mobile: state.Mobile,
			Email: state.Email,
			EID: state.EID,
			Passport: state.Passport,
			country: getLookupAsCountry( state.Country ),
			SharePerc: parseFloat( state.SharePerc! ),
			Documents: state.docs,
		};
		this.uploadPartyDocs( party ).then( ( party: Party ) => {
			this.dismissModel( party );
		} ).catch( ( reason ) => {
			showErrorMessage( reason );
		} );
	}

	private uploadPartyDocs( party: Party ): Promise<Party> {
		if ( party.Documents && party.Documents.length > 0 ) {
			this.setState( { isLoading: true } );
			return RTRegistrationApi.uploadDocuments( party.Documents ).then( ( docs ) => {
				party.Documents = docs;
				this.setState( { isLoading: false } );
				return Promise.resolve( party );
			} ).catch( ( e ) => {
				this.setState( { isLoading: false } );
				return Promise.reject( e );
			} );
		}
		return Promise.resolve( party );
	}

	private dismissModel( party?: Party ) {
		JQModal( "AddPartyPopup" ).hide();
		const { role, editIndex } = this.state;
		if ( party ) {
			if ( editIndex !== undefined ) {
				role.Parties[ editIndex ] = party;
			} else {
				role.Parties.push( party );
			}
			if ( this.props.onDismiss )
				this.props.onDismiss( role );
		} else {
			if ( this.props.onDismiss )
				this.props.onDismiss( undefined );
		}
	}
}

function stateFromProps( props: Props ) {
	const role: Role = _.cloneDeep( props.role );
	const editIndex = ( props.editIndex !== undefined ) ? props.editIndex : undefined;
	const parties: Party[] = ( role && role.Parties && role.Parties.length > 0 ) ? _.clone( role.Parties ) : [];
	const party = ( editIndex !== undefined && parties && parties.length > 0 ) ? _.clone( parties[ editIndex ] ) : undefined;
	const result: Partial<State> = {
		role: role,
		editIndex: editIndex,
		EnglishName: party ? party.EnglishName : "",
		ArabicName: party ? party.ArabicName : "",
		Mobile: party ? party.Mobile : "",
		Email: party ? party.Email : "",
		EID: party ? party.EID : "",
		Country: party ? getCountryAsLookup( party.country ) : undefined,
		Passport: party ? party.Passport : "",
		SharePerc: party ? "" + party.SharePerc : "",
		docs: ( party && party.Documents ) ? party.Documents : getPartyDocs(),
		error: {},
	};
	return result;
}

export function getCountryAsLookup( country?: Country ): TabuCountryLookup | undefined {
	if ( country ) {
		return {
			id: -1,
			NameAr: country.CountryNameAr,
			NameEn: country.CountryNameEn,
			CountryCode: "",
			NationalityAr: country.NationalityNameAr,
			NationalityEn: country.NationalityNameEn,
			Identity: country.CountryId,
		};
	}
	return undefined;
}

export function getLookupAsCountry( country?: TabuCountryLookup ): Country | undefined {
	if ( country ) {
		return {
			CountryId: country.Identity,
			CountryNameAr: country.NameAr,
			CountryNameEn: country.NameEn,
			NationalityNameAr: country.NationalityAr,
			NationalityNameEn: country.NationalityEn,
		};
	}
	return undefined;
}

export function RenderLoading() {
	return <div
		className={ "loader-container" }
		style={ { display: "block", left: 0, right: 0, zIndex: 9999 } }>
		<div className="cs-loader">
			<div className="cs-loader-inner">
				<span>●</span>
				<span>●</span>
				<span>●</span>
				<span>●</span>
				<span>●</span>
				<span>●</span>
			</div>
		</div>
	</div>;
}

export default AddPartyPopup;
